
// Intersection Observer to toggle visibility of sticky Add to Cart button

(function initStickyObserver(){
  let selector = window.innerWidth >= 750?desktopBuyWrapper:mobileBuyWrapper;
    const product = document.querySelector(`${selector}`);
    const stickyCartBtn = document.querySelector('.sticky_atc_wrapper');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyCartBtn.classList.remove('sticky')
        } else {
          stickyCartBtn.classList.add('sticky')
        }
      });
    }, { threshold: [0] });
    
    observer.observe(product);
})();


const initStickyObserver=()=>{
  let selector = window.innerWidth >= 750?desktopBuyWrapper:mobileBuyWrapper;
  const product = document.querySelector(`${selector}`);
    const stickyCartBtn = document.querySelector('.sticky_atc_wrapper');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyCartBtn.classList.remove('sticky')
        } else {
          stickyCartBtn.classList.add('sticky')
        }
      });
    }, { threshold: [0] });
    
    observer.observe(product);
}


/* adjusting quantities*/


const handleQuantityChange=(target)=>{
  const quantityElements=document.querySelectorAll(".quantity__input[name='quantity']");
  target.setAttribute("value",target.value)
  const currentQuantity = target;

  quantityElements.forEach(quantityEl=>{
    if(quantityEl != currentQuantity)
    quantityEl.setAttribute("value",currentQuantity.value)
    quantityEl.value=currentQuantity.value

  })

}

window.addEventListener('change',(event)=>{
  const {target} =event;
  if((target.classList.contains("quantity__input") || target.closest(".quantity__input")) && (target.hasAttribute("name") && target.getAttribute("name") =="quantity")){
    handleQuantityChange(target)
  }

})

window.addEventListener('click',(event)=>{
  const {target} =event;
  if((target.classList.contains("product-form__submit") || target.closest(".product-form__submit"))&&target.closest(".sticky_atc_container") && document.querySelector("[id^='mbcBundleItems']")){

    event.preventDefault();
    document.querySelector(".mbcOverlayOnBtn").click()
  }

})

//

/* adjusting quantities*/
